import React from "react";
import { Component } from "react";
import { Switch } from "react-router-dom";
import { Draggable, DragDropContext, Droppable } from "react-beautiful-dnd";
import { getBoundingClientRect } from "../../utils/functions";
import { checkTranslation, chooseFontColor, translate } from "../../utils/useful";
import LoaderButton from "../LoaderButton";
import FixedView from "../FixedView";
import { nanoid } from "nanoid";
import SelectInput from "./SelectInput";
import Dropzone from "react-dropzone";
import FormViewer from "../FormViewer";
import SwitchInput from "./SwitchInput";

// import React, { useRef, useState } from "react";

class VideoComponentFloatConfig extends Component {
  state = {

    imageSourceOptions: [],
    sizesFields: [
      { key: 'style.width', type: 'NumberInput', col: '9', information: { label: '{{lang}}Image width', maxValue: 100, placeholder: '{{lang}}width', required: false }, },

      { key: 'style.widthUnit', type: 'SelectInput', col: '3', information: { label: '\u200B', placeholder: '{{lang}}select', defaultValue: '%', items: [{ title: '%', value: '%' }, { title: 'px', value: 'px' },], emptyNotAllowed: true } },

      { key: 'style.maxWidth', type: 'NumberInput', col: '9', information: { label: '{{lang}}Max width', maxValue: 100, placeholder: '{{lang}}width', required: false }, },

      { key: 'style.maxWidthUnit', type: 'SelectInput', col: '3', information: { label: '\u200B', placeholder: '{{lang}}select', defaultValue: '%', items: [{ title: '%', value: '%' }, { title: 'px', value: 'px' },], emptyNotAllowed: true } },

      { key: 'style.align', type: 'SelectInput', col: '12', information: { label: '{{lang}}Alignment', placeholder: '{{lang}}select', defaultValue: 'center', items: [{ title: '{{lang}}Left', value: 'left' }, { title: '{{lang}}Center', value: 'center' }, { title: '{{lang}}Right', value: 'right' }], emptyNotAllowed: true } },

      { key: 'style.borderRadius', type: 'SidesInput', col: '12', information: { label: '{{lang}}Round corners', inputClass: 'none', placeholder: '{{lang}}Border radius' } },

      { key: 'style.margin', type: 'SidesInput', col: '12', information: { label: '{{lang}}Margin', inputClass: 'none', placeholder: '{{lang}}Margin' } },

      { key: 'style.padding', type: 'SidesInput', col: '12', information: { label: '{{lang}}Padding', inputClass: 'none', placeholder: '{{lang}}Padding' } },

    ],
  };

  componentDidMount() {
    setTimeout(() => {
      this.setState({ show: true })
    }, 10);

    this.createOptions()

  }

  componentDidUpdate(prevProps) {
    if (this.props.fields != prevProps.fields) {
      this.createOptions()
    }
  }

  createOptions = () => {
    let options = [{ title: '{{lang}}< Custom Video >', 'value': '**custom' }]

    let fields = this.props.fields

    if (fields) {
      fields.forEach(field => {
        if (field.type == 'VideoInput') {
          options.push({ title: field.information?.label, 'value': "{{" + field.key + "}}" })
        }
      });
    }

    this.setState({ imageSourceOptions: options })

  }

  setData = (key, value, myRef) => {
    if (myRef) {
      myRef.hideView()
    }

    this.props.setData(this.props.header?.id, key, value)
  }

  setElementSettings = (key, value) => {

    this.props.setElementSettings(this.props.index, key, value)

  }


  makeInvisible = () => {
    this.props.makeInvisible(this.props.header?.key, this.props.index)
  }

  changeSelectedTextEffects = (key, value, myRef) => {
    // "colorpicker"
    if (myRef) {
      myRef.hideView()
    }
    this.props.changeSelectedTextEffects({ effectType: key, value: value }, this.props.editorId)

  }

  changeFileTypeValue = (key, value) => {
    // let myValue = value
    // if(value != '**custom' && value){
    //   value = '{{'+value+'}}'
    // }
    this.setElementSettings('data', value)
    // setTimeout(() => {
    //   this.setElementSettings('infomration.source', "variable")

    // }, 10);

  }


  onDrop = (files, withCompression) => {

    console.log(files)
    // this.hideDropZone()
    // this.MessengerDropModal.showModal(files, withCompression)

    let filePath
    let showAlbum = false
    let view = 'file'
    files.forEach(element => {
      if (element.type.startsWith('image/') || element.type.startsWith('video/')) {
        showAlbum = true
      }
      filePath = URL.createObjectURL(element)
    });

    // if (withCompression) {
    //   view = 'album'
    // }

    this.setState({ droppedFile: files[0], filePath, showAlbum })


  }

  removeFromDroppedFiles = () => {
    this.setState({ droppedFile: null, filePath: null, showAlbum: false })

  }

  liveChange = (data, init, key, value, extra) => {

    this.props.setElementSettings(this.props.index, "information." + key, value)

  }


  render() {

    let source = this.props.element?.data//this.props.element?.information?.source

    console.log(this.props.element?.information)
    return (


      <div>

        <div className='h-100 w-100  d-flex pb-2' style={{ position: 'absolute', bottom: -40, left: 0, zIndex: 1, alignItems: 'flex-end', pointerEvents: 'none' }} onClick={e => e.stopPropagation()}>
          <div className='card-options-container flexc '>
            <img draggable={false} {...this.props.provided.dragHandleProps} src='/assets/icons/drag-and-drop.svg' height={14} className="builder-options-icon invert  mrd-3" />
            <img ref={(el) => (this.sourceSelectorBut = el)} onClick={() => this.imageSelector.showView()} src='/assets/icons/useful/gallery.png' height={14} className="builder-options-icon invert  mrd-3" />
            <img ref={(el) => (this.sizesBut = el)} onClick={() => this.sizesView.showView()} src='/assets/icons/useful/arrow.png' height={14} className="builder-options-icon invert  mrd-3" />
            {/* <img ref={(el) => (this.textAlignBut = el)} onClick={() => this.fontSizeView.showView()} src='/assets/icons/builder/align-left.png' height={14} className="builder-options-icon invert  mrd-3" /> */}
            <img ref={(el) => (this.textWeightBut = el)} onClick={() => this.textWeightView.showView()} src='/assets/icons/useful/filter 2.png' height={14} className="builder-options-icon invert  mrd-3" />

            {/* <img onClick={(e) => { e.stopPropagation(); this.doRemoveElement(e, section,) }} src='/assets/icons/useful/trash-o.svg' height={14} className="builder-options-icon invert  " /> */}

            <div className='mx-2' style={{ height: 16, width: 1, backgroundColor: '#ffffff50' }}>
            </div>

            {/* <img ref={(el) => (this.fieldLabelBut = el)} onClick={() => this.textWeightView.showView()} src='/assets/icons/builder/tag.png' height={14} className="builder-options-icon invert  mrd-3" /> */}
            <img ref={(el) => (this.fieldIconBut = el)} onClick={() => this.textWeightView.showView()} src='/assets/icons/useful/key.png' height={14} className="builder-options-icon invert  mrd-3" />

            <img ref={(el) => (this.changeVisiblityBut = el)} onClick={() => this.makeInvisible()} src='/assets/icons/useful/trash-o.svg' height={14} className="builder-options-icon invert mrd-3 " />

            {/* <img ref={(el) => (this.spacingBut = el)} onClick={() => this.fontSizeView.showView()} src='/assets/icons/builder/blank-space.png' height={14} className="builder-options-icon invert  " /> */}


            {/* <img src='/assets/icons/useful/row.png' height={14} className="builder-options-icon invert  mrd-2" />
                    <img src='/assets/icons/useful/column.png' height={14} className="builder-options-icon invert  mrd-2" /> */}

          </div>
        </div>

        {this.state.show && (
          <>


            <FixedView zIndex={10} ref={(el) => (this.imageSelector = el)} nodeRef={this.sizesBut} xOffset={44} bottomOffset={0} topOffset={10} maxWidth={300} width={300}   >
              <div className="bg-white br-10 p-1 shadow-3 w-100" onClick={e => e.stopPropagation()}>
                <div className=" p-1 sc-gray2" style={{ maxHeight: "250px", overflowY: "auto" }}   >


                  <div className="mb-1">
                    <div className="text-small mb-1 px-1 mt-1 required">
                      {translate("Just Show Cover")}
                    </div>
                    <div className="modern-input flexc ">
                      <SwitchInput data={this.props.element?.information?.showCover} header={{ key: 'showCover', information: { type: 'local', items: this.state.imageSourceOptions } }} changeValue={(key, value, extra) => { this.liveChange(null, false, key, value, extra) }} />
                    </div>
                  </div>


                  <div className="mb-1">
                    <div className="text-small mb-1 px-1 mt-1 required">
                      {translate("Video source")}
                    </div>
                    <div className="modern-input flexc ">
                      <SelectInput data={source} header={{ key: '', information: { type: 'local', items: this.state.imageSourceOptions } }} changeValue={this.changeFileTypeValue} />
                    </div>
                  </div>


                  {!this.state.filePath && (!source || source == '**custom') && (
                    <Dropzone
                      // disabled={this.props.disabled}
                      ref={el => this.dropzoneRef = el}
                      multiple={true}
                      // onDragLeave={this.hideDropZone}
                      accept='video/mp4'
                      onDrop={(e) => this.onDrop(e, false)}
                      // onDragOver={(e) => this.showDropZone(e, '2')}
                      style={{ flex: 1, cursor: 'pointer', outline: 'none' }}
                    >
                      {({ getRootProps, getInputProps }) => (

                        <div className=" w-100 flex-1 outline-none flexcc  pb-3 pt-2" {...getRootProps()} style={{ backgroundColor: '#fff' }}>
                          <input {...getInputProps()} />
                          <div className="w-100 h-100 flexcc flex-column px-3 py-4" style={{ border: '2px dashed #eee', borderRadius: 6, pointerEvents: 'none', backgroundColor: '#f6f6f6' }}>
                            <img className="" src={'/assets/icons/useful/clip.svg'} height={30} draggable={false} />
                            <p className="text-semibold text-small mt-2">{translate("Browes Files")}</p>
                            <p className="text-smaller mt-0 opacity-5">{translate("Or drop file here")}</p>
                          </div>
                        </div>
                      )}
                    </Dropzone>
                  )}


                  {this.props.element?.information?.showCover && (
                    <div className="mb-1">
                      <div className="text-small mb-1 px-1 mt-1 required">
                        {translate("Show Duration")}
                      </div>
                      <div className="modern-input flexc ">
                        <SwitchInput data={this.props.element?.information?.showDuration} header={{ key: 'showDuration', information: { type: 'local', items: this.state.imageSourceOptions } }} changeValue={(key, value, extra) => { this.liveChange(null, false, key, value, extra) }} />
                      </div>
                    </div>
                  )}

                  {this.state.filePath && (!source || source == '**custom') && (
                    <div className="flexc  flex-wrap position-relative">
                      <img src={this.state.filePath} width={'100%'} className="br-6" style={{ border: '1px solid #f6f6f6' }} />

                      <div className="flexcc position-absolute py-1 px-1" style={{ zIndex: 1, right: 5, bottom: 5, backgroundColor: '#00000080', borderRadius: 8 }}>
                        <button className="flexcc p-0 mrd-1" onClick={() => this.removeFromDroppedFiles()}>
                          <img className=" invert hover-opacity transition-all" src={'/assets/icons/useful/crop.svg'} height={20} style={{}} />
                        </button>

                        <button className="flexcc p-0" onClick={() => this.removeFromDroppedFiles()}>
                          <img className=" invert hover-opacity transition-all" src={'/assets/icons/useful/trash-o.svg'} height={20} style={{}} />
                        </button>

                      </div>


                    </div>
                  )}

                  {!(!source || source == '**custom') && (
                    <p className="text-smallest mt-2 px-1 mb-2 color-gray-2">{translate("The image source will be automatically generated based on the image source which you have selected.")}</p>
                  )}

                </div>
              </div>
            </FixedView>


            <FixedView zIndex={10} ref={(el) => (this.sizesView = el)} nodeRef={this.sourceSelectorBut} xOffset={-10} bottomOffset={0} topOffset={10} maxWidth={300} width={300}   >
              <div className="bg-white br-10 p-1 shadow-3 w-100" onClick={e => e.stopPropagation()}>
                <div className=" p-1 sc-gray2" style={{ maxHeight: "250px", overflowY: "auto" }}   >
                  <div className="flexcc flex-column w-100 px-1 py-2" >

                    <FormViewer ref={el => this.form = el} initData={this.props.element?.information} headers={this.state.sizesFields} formClass="modern" inputClass={'modern-input'} nopadding={true} liveChange={this.liveChange} />

                  </div>
                </div>
              </div>
            </FixedView>








            <FixedView zIndex={10} ref={(el) => (this.textWeightView = el)} nodeRef={this.textWeightBut} xOffset={-10} bottomOffset={0} topOffset={0} maxWidth={120} width={120}   >
              <div className="bg-white br-10 p-1 shadow-3 w-100" onClick={e => e.stopPropagation()}>
                <div className=" p-1 sc-gray2 w-100" style={{ maxHeight: "250px", overflowY: "auto" }}   >
                  <div className="flexcc flex-column ">

                  </div>
                </div>
              </div>
            </FixedView>

          </>
        )}
      </div>

    );
  }
}

export default VideoComponentFloatConfig;
